export var ApplePayPaymentTimingObj = ["immediate", "recurring", "deferred"];
/** @internal */
export var validateApplePayPaymentTiming = function (applePayPaymentTiming) {
    return ApplePayPaymentTimingObj.includes(applePayPaymentTiming);
};
